import React, { useEffect, useMemo, useRef, useState } from 'react';

const MultiSelectDropdown = ({
  options,
  value,
  onChange,
  placeholder = 'Sélectionner...',
  disabled = false,
  className = '',
}) => {
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);

  const selectedOptions = useMemo(() => {
    const set = new Set(value || []);
    return (options || []).filter(o => set.has(String(o.value)));
  }, [options, value]);

  useEffect(() => {
    if (!open) return;

    const onDocMouseDown = (e) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onDocMouseDown);
    return () => document.removeEventListener('mousedown', onDocMouseDown);
  }, [open]);

  const toggleValue = (v) => {
    const str = String(v);
    const current = Array.isArray(value) ? value.map(String) : [];
    const set = new Set(current);
    if (set.has(str)) {
      set.delete(str);
    } else {
      set.add(str);
    }
    onChange(Array.from(set));
  };

  const displayText = selectedOptions.length
    ? selectedOptions.map(o => o.label).join(', ')
    : placeholder;

  return (
    <div
      ref={containerRef}
      className={`msd-container ${disabled ? 'disabled' : ''} ${className}`}
    >
      <button
        type="button"
        className="msd-control"
        disabled={disabled}
        onClick={() => setOpen(prev => !prev)}
        aria-expanded={open}
      >
        <span className={`msd-value ${selectedOptions.length ? '' : 'placeholder'}`}>{displayText}</span>
        <span className="msd-arrow" />
      </button>

      {open && !disabled && (
        <div className="msd-menu" role="listbox" aria-multiselectable="true">
          {(options || []).map(opt => {
            const checked = (value || []).map(String).includes(String(opt.value));
            return (
              <button
                type="button"
                key={String(opt.value)}
                className={`msd-option ${checked ? 'selected' : ''}`}
                onClick={() => toggleValue(opt.value)}
              >
                <span className={`msd-selected-arrow ${checked ? 'on' : ''}`} aria-hidden="true" />
                <span className="msd-label">{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
